import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
    Badge,
    Box,
    Button,
    Center,
    Divider,
    FormControl,
    FormLabel,
    HStack,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverHeader,
    PopoverTrigger,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure,
    useToast,
    VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { deleteRoutePickupCompletely, fetchAllRoutes, fetchAllRoutesPickups, fetchFacilitiesBySearch, fetchLabLocationsOutside, searchRoutePickups } from '../../api';
import AccessDenied from '../../components/AccessDenied';
import Loading from '../../components/Loading/Loading';
import Pagination from '../../components/Pagination';
import TitleHeader from '../../components/TitleHeader';
import { getSelectStyles, hasPermission, useTableColors } from '../../Utils';
import EditPickupModal from './EditPickupModal';


const dayOptions = [
    { value: 'Monday', label: 'Monday' },
    { value: 'Tuesday', label: 'Tuesday' },
    { value: 'Wednesday', label: 'Wednesday' },
    { value: 'Thursday', label: 'Thursday' },
    { value: 'Friday', label: 'Friday' },
    { value: 'Saturday', label: 'Saturday' },
    { value: 'Sunday', label: 'Sunday' }
];
const AllRoutesPickups = () => {
    const navigate = useNavigate();
    const { isOpen: isDeleteModalOpen, onOpen: onOpenDeleteModal, onClose: onCloseDeleteModal } = useDisclosure();
    const toast = useToast()
    const [routesPickups, setRoutesPickups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingProcess, setLoadingProcess] = useState(false);
    const [selectedPickup, setSelectedPickup] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState(null);
    const {
        rowBgEven,
        rowBgOdd,
        rowHoverBg,
        textColor,
        borderColor,
        theadBg,
        dropOffBg,
        suppliesBg,
        selectBg, selectText, selectBorder,
        selectPlaceholder, selectMenuBg, selectMenuText,
        defaultRowColor,
        popoverBg,
        popoverColor
    } = useTableColors();

    const coolors = useTableColors();

    const itemsPerPage = 25;

    const [pickupLocation, setPickupLocation] = useState(null);
    const [dropOffLocation, setDropOffLocation] = useState(null);

    const [searching, setSearching] = useState(false);

    const [labLocations, setLabLocations] = useState([]);
    const [daysSelected, setSelectedDays] = useState([]); // Set as an array
    const [routeOption, setRouteOption] = useState();
    const [routes, setRoutes] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        console.log(routeOption)
    }, [routeOption])


    useEffect(() => {
        getRoutesPickups();
        getLabLocations();
        getRoutes();
    }, []);

    const getLabLocations = async () => {
        try {
            const response = await fetchLabLocationsOutside();
            if (response.success) {
                setLabLocations(response.data);
            }
        } catch (error) {
            console.log('Error loading lab locations');
        }
    };

    const getRoutesPickups = async (page = 1) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetchAllRoutesPickups(page, itemsPerPage);
            console.log(response)
            if (response.success) {
                setRoutesPickups(response.data.pickups);
                setCurrentPage(response.data.currentPage);
                setTotalPages(response.data.totalPages);
            } else {
                setError(response.error);
            }
        } catch (error) {
            setError('Failed to load routes');
        }
        setLoading(false);
    };

    const getRoutes = async () => {
        try {
            const response = await fetchAllRoutes(1, 999999);
            if (response.success) {
                setRoutes(response.data.routes);
            }
        } catch (error) {
            // setErrorModal('Error loading routes');
        }
    };

    useEffect(() => {
        console.log({ pickupLocation, dropOffLocation, daysSelected })
    }, [pickupLocation, dropOffLocation, daysSelected])

    const handleSearch = async (currentPage = 1) => {
        setLoading(true);
        try {
            const searchParams = {
                pickupLocationId: pickupLocation?.value || null,    // Extract value from react-select
                dropOffLocationId: dropOffLocation?.value || null,  // Extract value from react-select
                routeId: routeOption || null,  // Extract value from react-select
                days: daysSelected.length > 0 ? daysSelected.map(day => day.value) : [],  // Ensure days is an array
                page: currentPage,
                limit: itemsPerPage,
            };

            console.log(searchParams)
            setSearching(true)

            const response = await searchRoutePickups(searchParams);
            if (response.success) {

                setRoutesPickups(response.data.pickups);
                setCurrentPage(response.data.currentPage);
                setTotalPages(response.data.totalPages);

            } else {
                toast({
                    title: "Oops !",
                    description: response.error,
                    status: "error",
                    duration: 4000, // duration in milliseconds
                    isClosable: true,
                });

            }
        } catch (error) {
            console.error('Error performing search:', error);
        }
        setLoading(false);
    };

    const handleDeleteRoute = async () => {
        setLoadingProcess(true);
        try {
            const response = await deleteRoutePickupCompletely(selectedPickup._id);
            if (response.success) {
                setRoutesPickups(routesPickups.filter(route => route._id !== selectedPickup._id));
                toast({
                    title: "Removed Successful",
                    description: `The pickup has been removed Completely`,
                    status: "success",
                    duration: 1000, // duration in milliseconds
                    isClosable: true,
                });

                onCloseDeleteModal();
            } else {
                setError(response.error);
            }
        } catch (error) {
            setError('Error deleting route');
        }
        setLoadingProcess(false);
    };

    const clearSearch = () => {
        setSearching(false);
        setPickupLocation(null);
        setDropOffLocation(null);
        setSelectedDays([]);
        getRoutesPickups(); // Reloads default pickups data
    };

    const handlePageChanges = (page) => {
        if (searching) {
            handleSearch(page);
        } else {
            getRoutesPickups(page);
        }
    };



    const handlePickupUpdated = (updatedPickup) => {
        setRoutesPickups((prev) =>
            prev.map((pickup) => (pickup._id === updatedPickup._id ? updatedPickup : pickup))
        );
    };

    return (
        <Box maxW="full" mx="auto">
            <VStack spacing={6} align="stretch">
                <TitleHeader
                    title="Routes Pickups"
                />



                <HStack bg={theadBg} p={5} borderRadius={10} mb={3} spacing={4} align="start">
                    <FormControl isRequired>
                        <FormLabel>Pickup Location</FormLabel>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={fetchFacilitiesBySearch}
                            defaultOptions
                            onChange={(option) => setPickupLocation(option)}
                            value={pickupLocation || null}
                            placeholder="Search and select a facility"
                            closeMenuOnSelect={true}
                            isClearable
                            styles={getSelectStyles(coolors)}
                            classNamePrefix="rs"

                        />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel>Route</FormLabel>
                        <Select
                            options={routes.map((rou) => ({
                                value: rou._id,
                                label: `${rou.name}`,
                            }))}
                            onChange={(option) => setRouteOption(option ? option.value : "")}
                            value={
                                routeOption
                                    ? { value: routeOption, label: routes.find((f) => f._id === routeOption)?.name }
                                    : null
                            }
                            placeholder="Select a route"
                            isClearable
                            styles={getSelectStyles(coolors)}
                            classNamePrefix="rs"

                        />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel>Drop off Location</FormLabel>
                        <Select
                            cacheOptions
                            closeMenuOnSelect={true}
                            isClearable
                            options={labLocations.map((lab) => ({ value: lab._id, label: lab.name }))}
                            value={dropOffLocation}
                            onChange={(option) => setDropOffLocation(option || null)}
                            styles={getSelectStyles(coolors)}
                            classNamePrefix="rs"
                        />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel>Days</FormLabel>
                        <Select
                            isMulti
                            options={dayOptions}
                            value={daysSelected}
                            onChange={(selectedOptions) => setSelectedDays(selectedOptions || [])}
                            closeMenuOnSelect={false}
                            styles={getSelectStyles(coolors)}
                            classNamePrefix="rs"
                        />
                    </FormControl>

                    <VStack>
                        <Button mt={searching ? 0 : 34} colorScheme="blue" size="sm" onClick={() => handleSearch(1)}>
                            Search
                        </Button>
                        {searching && (
                            <Button colorScheme="red" size="sm" onClick={clearSearch}>
                                Clear
                            </Button>
                        )}
                    </VStack>
                </HStack>




                <Divider />

                {loading ?
                    <Center mt={"20%"}>
                        <Loading />
                    </Center>
                    :
                    <>
                        {error ? (
                            <AccessDenied msg={error} />
                        )
                            :
                            routesPickups.length > 0 ? (
                                <>
                                    <Table variant="simple">
                                        <Thead bg={theadBg}>
                                            <Tr>
                                                <Th>#</Th>
                                                <Th>Pickup</Th>
                                                <Th>Drop</Th>
                                                <Th>Day</Th>
                                                <Th>Type</Th>
                                                <Th>Route</Th>
                                                <Th>Created At</Th>
                                                <Th textAlign="right">Actions</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {routesPickups.map((route, index) => {
                                                const bg =
                                                    route.type === "DropOffOnly"
                                                        ? dropOffBg
                                                        : route.type === "Supplies"
                                                            ? suppliesBg
                                                            : index % 2 === 0
                                                                ? rowBgEven
                                                                : rowBgOdd;

                                                const color =
                                                    route.type === "Supplies"
                                                        ? "white"
                                                        : route.type === "DropOffOnly"
                                                            ? defaultRowColor
                                                            : defaultRowColor;

                                                return (
                                                    <Tr
                                                        key={route._id}
                                                        borderBottom="2px solid"
                                                        borderColor={borderColor}
                                                        bg={bg}
                                                        color={textColor}
                                                        _hover={{ bg: rowHoverBg, color: "white" }}
                                                    >
                                                        <Td>{index + 1}</Td>
                                                        <Td>{route?.pickupLocation?.name || "N/A"}</Td>
                                                        <Td>{route?.dropOffLocation?.name || "N/A"}</Td>

                                                        <Td>
                                                            <Popover>
                                                                <PopoverTrigger>
                                                                    <Badge cursor="pointer">View Days</Badge>
                                                                </PopoverTrigger>
                                                                <PopoverContent bg={popoverBg} color={popoverColor}>
                                                                    <PopoverArrow />
                                                                    <PopoverCloseButton />
                                                                    <PopoverHeader fontWeight="bold">Pickup Schedule</PopoverHeader>
                                                                    <PopoverBody>
                                                                        <Table variant="simple" size="sm">
                                                                            <Thead bg={theadBg}>
                                                                                <Tr>
                                                                                    <Th>Day</Th>
                                                                                    <Th>Pickup Order</Th>
                                                                                </Tr>
                                                                            </Thead>
                                                                            <Tbody>
                                                                                {route.pickupDays.map((day) => (
                                                                                    <Tr key={day._id}>
                                                                                        <Td>{day.day}</Td>
                                                                                        <Td>{day.pickupOrder}</Td>
                                                                                    </Tr>
                                                                                ))}
                                                                            </Tbody>
                                                                        </Table>
                                                                    </PopoverBody>
                                                                </PopoverContent>
                                                            </Popover>
                                                        </Td>

                                                        <Td>
                                                            <Badge
                                                                colorScheme={
                                                                    route.type === "DropOffOnly"
                                                                        ? "pink"
                                                                        : route.type === "Supplies"
                                                                            ? "purple"
                                                                            : "orange"
                                                                }
                                                            >
                                                                {route.type === "DropOffOnly"
                                                                    ? "Drop Off"
                                                                    : route.type === "Default"
                                                                        ? "Pickup"
                                                                        : route.type}
                                                            </Badge>
                                                        </Td>

                                                        <Td>
                                                            <Badge
                                                                cursor="pointer"
                                                                onClick={() => navigate(`/routes/view/${route.routeId._id}`)}
                                                                colorScheme="red"
                                                            >
                                                                {route.routeId.name}
                                                            </Badge>
                                                        </Td>

                                                        <Td>{new Date(route.createdAt).toLocaleDateString()}</Td>

                                                        <Td textAlign="right">
                                                            <HStack justifyContent="flex-end" spacing={4}>
                                                                {hasPermission("deleteRoutePickup") && (
                                                                    <Button
                                                                        onClick={() => {
                                                                            setSelectedPickup(route);
                                                                            onOpenDeleteModal();
                                                                        }}
                                                                        size="xs"
                                                                        colorScheme="red"
                                                                    >
                                                                        <DeleteIcon mr={2} /> Delete
                                                                    </Button>
                                                                )}
                                                                {hasPermission("updateRoutePickup") && route.type === "Default" && (
                                                                    <Button
                                                                        onClick={() => {
                                                                            setSelectedPickup(route);
                                                                            onOpen();
                                                                        }}
                                                                        size="xs"
                                                                        colorScheme="blue"
                                                                    >
                                                                        <EditIcon mr={2} /> Edit
                                                                    </Button>
                                                                )}
                                                            </HStack>
                                                        </Td>
                                                    </Tr>
                                                );
                                            })}
                                        </Tbody>
                                    </Table>


                                    <Pagination currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChanges} />
                                </>
                            ) : (
                                <AccessDenied msg="Nothing here yet !" icon='info' />
                            )}
                        {selectedPickup &&

                            <>
                                <Modal isOpen={isDeleteModalOpen} onClose={onCloseDeleteModal}>
                                    <ModalOverlay />
                                    <ModalContent>
                                        <ModalHeader>Confirm Deletion</ModalHeader>
                                        <ModalBody>
                                            Are you sure you want to delete this pickup ?
                                            <br /><br />
                                            <strong>{selectedPickup?.pickupLocation?.name}</strong>
                                            <br /><br />
                                            This will remove it form all day's and not just one day ?
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button isLoading={loadingProcess} colorScheme="red" onClick={handleDeleteRoute}>Delete</Button>
                                            <Button onClick={onCloseDeleteModal}>Cancel</Button>
                                        </ModalFooter>
                                    </ModalContent>
                                </Modal>


                                <EditPickupModal
                                    isOpen={isOpen}
                                    onClose={() => {
                                        setSelectedPickup(null);
                                        onClose();
                                    }}
                                    onPickupUpdated={handlePickupUpdated}
                                    pickupData={selectedPickup}
                                />
                            </>



                        }
                    </>
                }



            </VStack>
        </Box >
    );
};

export default AllRoutesPickups;
